export enum CartVariants {
  sample = 'sample',
}
